import type React from "react"
import { memo } from "react"
import { twJoin } from "tailwind-merge"

type UploadButtonProps = {
  label: string
  className: string
  inputFor: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value?: string | number | readonly string[] | undefined
  accept?: string
}

const UploadButton: React.FC<UploadButtonProps> = ({
  label,
  className,
  inputFor,
  onChange,
  value,
  accept = "application/pdf",
}) => {
  return (
    <div>
      <label className={twJoin(className)} htmlFor={inputFor}>
        {label}
      </label>
      <input
        accept={accept}
        onChange={onChange}
        value={value}
        type="file"
        name={inputFor}
        id={inputFor}
        className="w-0 h-0 opacity-0 overflow-hidden absolute -z-[1]"
      />
    </div>
  )
}
export default memo(UploadButton)
